module.exports = __webpack_public_path__ + "static/media/slick.ced611da.eot";


//////////////////
// WEBPACK FOOTER
// ./~/slick-carousel/slick/fonts/slick.eot
// module id = 183
// module chunks = 0